module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/suns_sns_02-2c7e4771039d8379c4aeec3053cf20b3.jpg";